//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.GPodaniOpravaPisemnostiDlg.ts        </Name>
//    <Description> Dialog opravy písemnosti                                    </Description>
//    <Author>      Šebesta David                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-05-24                                                  </Created>
//  </FileHeader>


namespace Gordic.Pod.WebControls {
    const { gcontent } = Decorators


    /**
     * GPodaniOpravaPisemnostiDlg
     *
     * @returns
     */
    @gcontent
    export class AntivirInfoDlg extends GContentBase {
        //#region Property
     

        private readonly Title: string
        private model: Interface.AntivirInfoDto
        private $Formular?: JQuery<HTMLElement>   // zakladní hlavička

        /**
         * OnContentReady.
         *
         * @author  dsebesta
         * @date    01.09.2017
         */
        public onContentReady(): void {
            const that: AntivirInfoDlg = this;

            this.beginOperation();
            this.createAction();
            this.createForm();
            this.endOperation();
        }

      


        private createAction(): void{
            var that = this;     
            this.actions.add(new GAction(Gordic.Prefabs.Actions.ZavritContent(
            )));

            this.commandBar(this.actions.createBar([
                Gordic.Prefabs.Actions.Names.ZavritContent
                ]
            ));
        }


        private createForm(): void {
            var that = this;


            const form = new Gordic.Forms.Form({
                layoutDescriptor: "L1M2S1",
                name: "Oprava",
                //tabOptions: {
                //    title: "jres:26225303", //RC 26225303 : Hledání zásilek
                //    opened: false
                //}
            } as any)
                .addSection();


            form.addRow("jres:31950227") //RC 31950227 : Produkt
                .addText(this.model.Produkt)
                .addRow("jres:31950228") //RC 31950228 : Výrobce
                .addText(this.model.Provider)
                .addRow("jres:31950229") //RC 31950229 : Verze
                .addText(this.model.ProductVerze)
                .addRow("jres:31950230") //RC 31950230 : DB verze
                .addText(this.model.DatabaseVerze)
                .addRow("jres:31950231") //RC 31950231 : Datum produktu
                .addText(this.model.ProductDate)
                .addRow("jres:31950232") //RC 31950232 : DB datum
                .addText(this.model.DatabaseDate)


           
            this.$Formular = $("<div>").appendTo(this.element).gform("createFrom", form);
        }


                
           
        //#endregion
    }

}